import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/img/404.png';
const _hoisted_1 = {
  class: "page-404"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "title"
  }, [_createElementVNode("h2", null, "页面走丢了..."), _createElementVNode("h4", null, "您所请求的页面不存在！"), _createElementVNode("h4", null, "请仔细检查您输入的网址是否正确。")], -1)), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back())
  }, "返  回")]);
}